
  import Notification from  '@/components/Notification';
  import { decryptionData } from '@/components/utils/utils.js';
  import axios from "axios";
  import { mapGetters } from 'vuex';
  export default {
    components: {
      Notification: Notification
    },
    data: () => ({
      search:'',
      btnload:false,
      alertSuccess:'',
      alertFailed:'',
      alert_err_attention: "",
      deleteact: false,
      insertact: false,
      updateact: false,
      viewact: false,
      dialogApproved: false,
      dialogReject: false,


      roleKeyword: [],
      dialogRoleKeyword: false,
      selectedRoleKeyword: null,

      approveData: {
        userId: null,
        type: null,
        email: null
      },

      headers: [
        { text: 'Username', value: 'USERNAME' },
        { text: 'E-mail', value: 'EMAIL' },
        { text: 'Created Date', value: 'CREATED_DATE' },
        { text: 'Group', value: 'GROUP_NAME' },
        { text: 'Actions', value: 'actions', width: '200px', sortable: false },
      ],

      // HEADER TAB COMPANY
      headersCompany: [
        { text: 'Username', value: 'USERNAME' },
        { text: 'E-mail', value: 'EMAIL' },
        { text: 'Created Date', value: 'CREATED_DATE' },
        { text: 'Group', value: 'GROUP_NAME' },
        { text: 'Actions', value: 'actions', width: '200px', sortable: false },
      ],

      // HEADER TAB PERSONAL
      headersPersonal: [
        { text: 'Username', value: 'USERNAME' },
        { text: 'Full Name', value: 'FULLNAME' },
        { text: 'Phone', value: 'MOBILE' },
        { text: 'Created Date', value: 'CREATED_AT' },
        { text: 'Actions', value: 'actions', width: '200px', sortable: false },
      ],
      tab: 0,
      usermanagement: [],
      userCompany: [],
      userPersonal: [],

      idUsersRegister:'',
      flagActions:'',// 1 Company, 2 Personal
      emailSend:'',

    }),
    computed: {
      page() {
        return this.$store.state.breadcrumbs
      },
      ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
    },
    watch: {
      dialogApproved (val) {
        val || this.closeApprove()
      },
      dialogReject (val) {
        val || this.closeReject()
      },
    },
    created () {
      this.initialize()
    },
    props: ['userId'], 
    mounted() {
      console.log('User ID:', this.userId);  // Cek apakah userId diterima dengan benar
    },
    methods: {
      async initialize () {
        this.tableLoading = true;
        this.usermanagement = [];
        axios.get("users-register",
          { headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          ).then((response) => {
            let res = decryptionData(response.data.token);
            var propuserId = this.userId;
            if(propuserId  != undefined){
              this.userCompany = res.user_company.filter(item => item.USER_ID === Number(this.userId));
              this.userPersonal = res.user_personal.filter(item => item.SEQ_ID === Number(this.userId));
              this.deleteact = true 
              this.insertact = true 
              this.updateact = true 
              this.viewact = true 
            }else{
              this.userCompany = res.user_company;
              this.userPersonal = res.user_personal;
              this.roleKeyword = res.role_keyword;
              if(localStorage.getItem('authactdeletedt') == 1){ this.deleteact = true }
              if(localStorage.getItem('authactinsert') == 1){ this.insertact = true }
              if(localStorage.getItem('authactupdate') == 1){ this.updateact = true }
              if(localStorage.getItem('authactview') == 1){ this.viewact = true }
            }
            this.tableLoading = false;
            setTimeout(() =>{
              this.loading = false
            },1000)

          })
          .catch((e) => {
              switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                  }
            this.tableLoading = false;

          this.errors=e.response.data.msg;
        });
      },

      rejectItem (item,flagActions,emailSend) {
        this.emailSend = emailSend
        this.flagActions = flagActions
        this.idUsersRegister = item
        this.dialogReject = true
      },
      rejectItemConfirm () {
        axios({
          method: "delete",
          url: "/reject-user-registrasi",
          data: {
            id: this.idUsersRegister,
            flagActions: this.flagActions,
            emailSend: this.emailSend
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
          // handle success
              var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.alertSuccess = true;
                this.alert_err_attention =  messages;
                this.closeReject()
              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
                  this.closeReject()
              } 
              this.initialize();
        })
        .catch(function (error) {
              this.alertFailed = true;
              this.alert_err_attention =  'Delete Failed '+error;
              this.closeReject()
        })
        this.closeReject()
      },
      closeReject () {
        this.dialogReject = false

      },
      openRoleKeywordDialog(item) {
        this.approveData = {
          userId: item.SEQ_ID,
          type: 2,
          email: item.EMAIL
        }

        this.selectedRoleKeyword = null
        this.dialogRoleKeyword = true
      },
      continueApprove() {
        if (!this.selectedRoleKeyword) {
          this.alertFailed = true
          this.alert_err_attention = "Role keywords must be selected"
          return
        }

        this.dialogRoleKeyword = false

        this.approveItem(
          this.approveData.userId,
          this.approveData.type,
          this.approveData.email,
          this.selectedRoleKeyword
        )
      },
      closeRoleKeyword() {
        this.dialogRoleKeyword = false
        this.selectedRoleKeyword = null
      },
      approveItem (item,flagActions,emailSend) {
        this.emailSend = emailSend
        this.flagActions = flagActions
        this.idUsersRegister = item
        this.dialogApproved = true
      },
      approveItemConfirm () {
        axios({
          method: "put",
          url: "/approve-user-registrasi",
          data: {
            id: this.idUsersRegister,
            flagActions: this.flagActions,
            emailSend: this.emailSend,
            roleKeywordId: this.selectedRoleKeyword
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
          // handle success
              var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.alertSuccess = true;
                this.alert_err_attention =  messages;
                this.closeApprove()
              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
                  this.closeApprove()
              } 
              this.initialize();
        })
        .catch(function (error) {
              this.alertFailed = true;
              this.alert_err_attention =  'Delete Failed '+error;
              this.closeApprove()
        })
        this.closeApprove()
      },
      closeApprove () {
        this.dialogApproved = false
      },
      
    },
  }